import { useBlockProps, RichText } from '@wordpress/block-editor';
import classnames from 'classnames';
const agentImage = require('./image/user.jpg');
export default function save({ attributes }) {
	const {
		buttonSize,
		borderRadius,
		buttonType,
		text,
		info,
		title,
		online,
		offline,
		textAlignment,
		buttonLinkTarget,
		numberInput,
		visibility,
		iconTarget,
		imageUrl,
		timeZone,
		mondayStartTime,
		mondayEndTime,
		tuesdayStartTime,
		tuesdayEndTime,
		wednesdayStartTime,
		wednesdayEndTime,
		thursdayStartTime,
		thursdayEndTime,
		fridayStartTime,
		fridayEndTime,
		saturdayStartTime,
		saturdayEndTime,
		sundayStartTime,
		sundayEndTime,
	} = attributes;

	const viberLink = `viber://chat?number=${numberInput}`;

	const textClasses = classnames(`text-box-align-${textAlignment}`);
	const basicBtnClasses = classnames(`vChat-button-4 vc-btn-bg`);
	const advanceBtnClasses = classnames(`vcButtons viber__target vChat-button-4 vc-btn-bg`);
	return (
		<>
			{buttonType === 'basic-button' ? (
				<div className={`button-wrapper ${textClasses}`}>
					<a href={viberLink}
						{...useBlockProps.save({
							className: `viber__target ${basicBtnClasses} ${buttonSize} ${borderRadius} ${visibility}`,
						})}
						
					>
						{iconTarget && (
							<span className="dashicons dashicons-share-alt"></span>
						)}
						<RichText.Content tagName="span" value={text} />
						
					</a>
				</div>
			) : (
				<div className={`button-wrapper ${textClasses}`}>
					<button
						{...useBlockProps.save({
							className: `${advanceBtnClasses} ${buttonSize} ${borderRadius} ${visibility}`,
						})}
						data-timezone={timeZone}
						data-btnavailablety={`{ "monday":"${mondayStartTime}-${mondayEndTime}", "tuesday":"${tuesdayStartTime}-${tuesdayEndTime}", "wednesday":"${wednesdayStartTime}-${wednesdayEndTime}", "thursday":"${thursdayStartTime}-${thursdayEndTime}", "friday":"${fridayStartTime}-${fridayEndTime}", "saturday":"${saturdayStartTime}-${saturdayEndTime}", "sunday":"${sundayStartTime}-${sundayEndTime}" }`}
					>
						<img src={imageUrl ? imageUrl : agentImage} alt="agent" />
						<div className="info-wrapper">
							<RichText.Content
								value={info}
								tagName="p"
								className="info"
							/>
							<RichText.Content
								value={title}
								tagName="p"
								className="title"
							/>
							<RichText.Content
								value={online}
								tagName="p"
								className="online"
							/>
							<RichText.Content
								value={offline}
								tagName="p"
								className="offline"
							/>
						</div>
						<a href={viberLink}></a>
					</button>
				</div>
			)}
		</>
	);
}
